module.exports = __webpack_public_path__ + "img/img77.fa4aa4d4.png";